import gql from 'graphql-tag';

export default gql`
  query GetAccountNftList($address: String, $limit: Int, $offset: Int) {
    current_token_ownerships_v2(
      where: { owner_address: { _eq: $address }, amount: { _gt: "0" } }
      limit: $limit
      offset: $offset
    ) {
      amount
    	storage_id
      current_token_data {
        token_name
        supply
        maximum
        token_uri
        largest_property_version_v1
        current_collection {
          collection_name
          creator_address
          description
        }
      }
    }
  }
`;
